import type { TransactionEvent } from '@sentry/core'

/** Paths we do not send as performance transactions (health, version probe, high-volume webhooks). */
export const DROPPED_SENTRY_TRANSACTION_PATHS = ['/ready', '/metrics', '/getApiVersion', '/cio-tracking', 'schema-reporting'] as const

export function pathFromSentryTransactionEvent(event: TransactionEvent): string {
  const name = event.transaction?.trim()
  if (name) {
    const space = name.indexOf(' ')
    const pathPart = space === -1 ? name : name.slice(space + 1)
    return pathPart.split('?')[0] || ''
  }
  const url = event.request?.url
  if (!url) return ''
  const noQuery = url.split('?')[0] || ''
  if (noQuery.startsWith('/')) return noQuery
  const pathStart = noQuery.indexOf('/', noQuery.indexOf('//') + 2)
  if (pathStart === -1) return '/'
  return noQuery.slice(pathStart) || '/'
}

export function shouldDropSentryTransaction(event: TransactionEvent): boolean {
  const path = pathFromSentryTransactionEvent(event)
  if (!path) return false
  return DROPPED_SENTRY_TRANSACTION_PATHS.some(p => path.includes(p))
}
